import NavigationTag from './NavigationTag';

export default {
  name: 'dn-navigation-tags',

  props: {
    link: Object,
    tag: {
      type: String,
      default: 'ul',
    },
    lg: Boolean,
    title: String,
  },

  computed: {
    tags() {
      let { link } = this;
      if (!link) {
        link = this.$store.getters['navigation/matchedLink'];
      }
      return link && link.tags ? link.tags : null;
    },
    childTag() {
      return this.tag === 'ul' ? 'li' : 'span';
    },
  },

  render(h) {
    const { tags } = this;
    if (!tags) return;

    const $children = tags.map(tag => h(NavigationTag, {
      props: {
        tag: this.childTag,
        lg: this.lg,
      },
    }, tag));

    const $tags = h(this.tag, {
      staticClass: 'dn-navigation-tags',
    }, $children);

    if (!this.title) return $tags;

    return h('dl', {
      staticClass: 'dn-navigation-tags-wrapper',
    }, [
      h('dt', {
        staticClass: 'dn-navigation-tags-wrapper__ttl',
      }, this.title),
      h('dd', {
        staticClass: 'dn-navigation-tags-wrapper__body',
      }, $children),
    ]);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/NavigationTags.js